import React, { useEffect, useState } from "react";
import api from "../api/axios";
import EditProductVariant from "./EditProductVariant"; // Importamos el componente hijo
import { Pencil } from "lucide-react";
import { getExpirationStatus } from "../helpers/expirationStatus";
import { formatDate } from "../utils/format";


function ProductVariantsModal({ product, onClose }) {
  const [variants, setVariants] = useState([]);
  const [editingVariant, setEditingVariant] = useState(null); // Estado para la segunda modal

  useEffect(() => {
    if (product?.id) {
      api
        .get(`/product-variants/product/${product.id}`)
        .then((res) => {
          const filteredVariants = res.data.filter(
            (variant) => (variant.inventories?.[0]?.current_quantity ?? 0) > 0
          );
          setVariants(filteredVariants);
        })
        .catch(() => alert("Error al obtener variantes"));
    }
  }, [product]);

  const handleBackdropClick = (e) => {
    if (e.target.id === "modal-backdrop") {
      onClose();
    }
  };

  return (
    <>
      {/* Modal principal */}
      <div
        id="modal-backdrop"
        className="fixed inset-0 bg-black bg-opacity-40 flex items-start justify-center z-50"
        onClick={handleBackdropClick}
      >
        <div className="bg-white rounded-xl w-full max-w-7xl p-6 shadow-lg relative mt-6">
          <div className="mb-6 text-center">
            <h2 className="text-3xl font-bold text-gray-800">
              {product.name}
            </h2>

            {product.description && (
              <p className="mt-2 max-w-4xl mx-auto">
                {product.description}
              </p>
            )}

            <div className="flex justify-center gap-6 mt-4 text-sm">
              <span className="bg-blue-100 text-blue-700 px-3 py-1 rounded-full">
                <strong>Vida útil:</strong> {product.useful_life}
              </span>

              <span className="bg-red-100 text-red-700 px-3 py-1 rounded-full">
                <strong>Riesgo:</strong> {product.risk}
              </span>

              {String(product.category_id) === "11" && (
                <span className="bg-purple-100 text-purple-700 px-3 py-1 rounded-full">
                  <strong>CUM:</strong> {product.cum || "—"}
                </span>
              )}
            </div>
          </div>
          <button
            onClick={onClose}
            className="absolute top-3 right-4 text-gray-600 hover:text-red-500 text-xl"
          >
            ✕
          </button>

          <div className="overflow-x-auto">
            <table className="min-w-full bg-white table-auto border">
              <thead>
                <tr className="bg-gray-100 text-gray-700 text-sm uppercase">
                  <th className="px-4 py-2">Marca</th>
                  <th className="px-4 py-2">Presentación</th>
                  <th className="px-4 py-2">Invima</th>
                  <th className="px-4 py-2">Lote</th>
                  <th className="px-4 py-2">Vencimiento</th>
                  <th className="px-4 py-2">Cantidad</th>
                  <th className="px-4 py-2">Estado</th>
                  <th className="px-4 py-2">Acción</th>
                </tr>
              </thead>

              <tbody className="text-center">
                {variants.map((variant, index) => {
                  const { colorClass, tooltip } = getExpirationStatus(
                    variant.expiration_date
                  );

                  return (
                    <tr
                      key={variant.id}
                      className={index % 2 === 0 ? "bg-white" : "bg-gray-50"}
                    >
                      <td className="px-4 py-2">
                        {variant.brand?.name || "—"}
                      </td>

                      <td className="px-4 py-2">
                        {variant.presentation?.name || "—"}
                      </td>

                      <td className="px-4 py-2">
                        {variant.invima_code || "—"}
                      </td>

                      <td className="px-4 py-2">
                        {variant.batch_number || "—"}
                      </td>

                      {/* Fecha */}
                      <td className="px-4 py-2">
                        {variant.expiration_date
                          ? formatDate(variant.expiration_date)
                          : "NR"}
                      </td>


                      {/* Stock */}
                      <td className="px-4 py-2">
                        {variant.inventories?.[0]?.current_quantity ?? 0}
                      </td>

                      {/* Estado */}
                      <td className="px-4 py-2">
                        <div
                          className={`w-4 h-4 rounded-full mx-auto ${colorClass}`}
                          title={tooltip}
                        />
                      </td>

                      {/* Acciones */}
                      <td className="px-4 py-2">
                        <div className="flex justify-center gap-2">
                          <button
                            onClick={() => setEditingVariant(variant)}
                            className="bg-yellow-400 hover:bg-yellow-500 text-white p-2 rounded-lg shadow transition-all duration-300"
                            title="Editar variante"
                          >
                            <Pencil size={16} />
                          </button>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* Segunda modal: editar variante */}
      {editingVariant && (
        <EditProductVariant
          variant={editingVariant}
          onClose={() => setEditingVariant(null)}
          onUpdate={() => {
            api
              .get(`/product-variants/product/${product.id}`)
              .then((res) => {
                const filteredVariants = res.data.filter(
                  (variant) => (variant.inventories?.[0]?.current_quantity ?? 0) > 0
                );
                setVariants(filteredVariants);
              })
              .catch(() => alert("Error al actualizar variantes"));
            setEditingVariant(null);
          }}

        />
      )}
    </>
  );
}

export default ProductVariantsModal;
